const CheckboxGroupData = {
  items: [
    {
      name: "Share by email",
      value: "a",
      required: false,
    },
    {
      name: "Copy to clipboard",
      value: "b",
      required: false,
    },
    {
      name: "Download a deposit slip",
      value: "c",
      required: true,
    },
  ],
};

export default CheckboxGroupData;
